/**
 * App Component — HMVM Reviewer product shell and routes.
 */

import { Navigate, Routes, Route } from 'react-router-dom'
import { AppContextProvider } from './contexts/AppContext'
import { LocaleProvider } from './contexts/LocaleContext'
import { ReviewSessionProvider } from './contexts/ReviewSessionContext'
import Shell from './components/Shell'
import { AuthGate } from './components/AuthGate'

import StatusPage from './pages/StatusPage'
import PreflightPage from './pages/PreflightPage'
import { DashboardPage } from './pages/DashboardPage'
import { FindingsTablePage } from './pages/FindingsTablePage'
import { FindingDetailsPage } from './pages/FindingDetailsPage'
import { AuditDetailsPage } from './pages/AuditDetailsPage'
import { DesignSystemPreviewPage } from './pages/DesignSystemPreviewPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { AuditsPage } from './pages/AuditsPage'
import { EvidencePage } from './pages/EvidencePage'
import { ScoresPage } from './pages/ScoresPage'
import { ReportsPage } from './pages/ReportsPage'
import { FixWithAiPage } from './pages/FixWithAiPage'
import { FixRunHistoryPage } from './pages/FixRunHistoryPage'
import { FixRunDetailPage } from './pages/FixRunDetailPage'
import { ReauditPage } from './pages/ReauditPage'
import { KnowledgeBasePage } from './pages/KnowledgeBasePage'
import { KnowledgeBaseDetailPage } from './pages/KnowledgeBaseDetailPage'
import { KnowledgeControlPage } from './pages/KnowledgeControlPage'
import { KnowledgeControlDetailPage } from './pages/KnowledgeControlDetailPage'
import { KnowledgePacksPage } from './pages/KnowledgePacksPage'
import { KnowledgePackDetailPage } from './pages/KnowledgePackDetailPage'
import { SettingsPage } from './pages/SettingsPage'

function App() {
  return (
    <LocaleProvider>
    <ReviewSessionProvider>
    <AuthGate>
    <AppContextProvider>
      <Shell>
        <Routes>
          {/* Legacy/Root Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/status" element={<StatusPage />} />
          
          {/* Overview Group */}
          <Route path="/dashboard" element={<DashboardPage />} />
          
          {/* Projects & Audits Group */}
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/audits" element={<AuditsPage />} />
          <Route path="/audit/:auditId" element={<AuditDetailsPage />} />
          
          {/* Investigation Group */}
          <Route path="/findings" element={<FindingsTablePage />} />
          <Route path="/finding/:findingId" element={<FindingDetailsPage />} />
          <Route path="/evidence" element={<EvidencePage />} />
          
          {/* Analysis Group */}
          <Route path="/scores" element={<ScoresPage />} />
          <Route path="/audit/:auditId/scores" element={<ScoresPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/audit/:auditId/reports" element={<ReportsPage />} />
          
          {/* AI & Automation Group */}
          <Route path="/fix-with-ai" element={<FixWithAiPage />} />
          <Route path="/audit/:auditId/fixruns" element={<FixRunHistoryPage />} />
          <Route path="/fix/:fixRunId" element={<FixRunDetailPage />} />
          <Route path="/re-audit" element={<ReauditPage />} />
          
          {/* Knowledge Group */}
          <Route path="/knowledge" element={<Navigate to="/knowledge-base" replace />} />
          <Route path="/knowledge-base" element={<KnowledgeBasePage />} />
          <Route path="/knowledge-base/:entryId" element={<KnowledgeBaseDetailPage />} />
          <Route path="/knowledge-control" element={<KnowledgeControlPage />} />
          <Route path="/knowledge-control/packs" element={<KnowledgePacksPage />} />
          <Route path="/knowledge-control/packs/:packId" element={<KnowledgePackDetailPage />} />
          <Route path="/knowledge-control/:ruleId" element={<KnowledgeControlDetailPage />} />
          
          {/* Admin Group */}
          <Route path="/settings" element={<SettingsPage />} />
          
          {/* Special Routes */}
          <Route path="/design-system" element={<DesignSystemPreviewPage />} />
          <Route path="/preflight/:preflightId" element={<PreflightPage />} />
        </Routes>
      </Shell>
    </AppContextProvider>
    </AuthGate>
    </ReviewSessionProvider>
    </LocaleProvider>
  )
}

export default App
